<template>
<div>

    <div class="backgroundWhiteList mt-16">
        <div
              class="w-full bg-gray-800 rounded-[24px] flex flex-col gap-4 lg:flex-row justify-between px-8 py-6 md:px-12 md:py-10 mb-16 border-sky-500 border-4"
            >
              <span class="text-4xl text-white font-medium">Search Discord Entries</span>
              <div
                class="flex justify-center rounded-[12px] text-lg md:text-2xl px-1 font-medium"
              >
                <input
                    class="mt-3 bg-gray-15 font-medium text-white-64 rounded-[10px] h-[48px] flex justify-center items-center text-center"
                    type="text"
                    v-model="discordSearch"
                    placeholder="Proj Name"
                  />
                <button @click="popModal()" class="w-full h-[48px] text-white rounded-[10px] font-medium searchButton">SEARCH</button>
              </div>
            </div>

            <b-modal size="xl" ref="enteredList" hide-footer >
              <div class="d-block text-center" v-for="(entered) in projectsEntered" :key="entered">
                <h3>{{entered.discord}} - {{entered.wallet}}</h3><br>
              </div>
            </b-modal>
    </div>
</div>
</template>

<script>
import axios from "axios";

export default {
    data: function() {
        return {
            discordSearch: "",

            totalDBList: [],

            projectsEntered: [],
        }
    },
    mounted() {
        this.checkAll();
    },
    methods:{
        async checkAll() {
           
            await axios
                .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
                .then(response => {
                    this.totalDBList = response.data.data;
                })
                .catch(err => {
                this.loadingTransaction = false;
                });
        },
        popModal()
        {

            this.projectsEntered = [];
            for(var i=0; i<this.totalDBList.length; i++)
            {
                if(this.totalDBList[i].whiteListChoice === this.discordSearch)
                {
                    var options = {discord: this.totalDBList[i].discordName, wallet: this.totalDBList[i].address}
                    this.projectsEntered.push(options);
                }
            }
            this.$refs['enteredList'].show()

        },
    }
}
</script>

<style scoped>
.searchButton
{
  margin-top: 1.5vh;
  margin-left: 1vh;
}

.bg-black-80 {
  background-color: rgba(0, 0, 0, 0.65);
}
.bg-gray-15 {
  background-color: rgba(255, 255, 255, 0.15);
}
.bg-gray-32 {
  background-color: rgba(255, 255, 255, 0.32);
}
.text-white-64 {
  color: rgba(255, 255, 255, 0.64);
}
.text-neon {
  color: #10ecff;
}
.smallText {
  color: #f8ff00;
}
.highlight {
  color: #f8ff00;
}
.whiteToken {
  color: #10ecff;
}
.cutSpanRaffle {
  color: #10ecff;
}
</style>


// WEBPACK FOOTER //
// src/components/Store/dbSearch.vue